module.exports = __webpack_public_path__ + "static/media/simonSound4.f4a912ee.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Simon/sounds/simonSound4.mp3
// module id = 89
// module chunks = 0